(() => {
  const root = document.querySelector('[data-pn-reader-wishlist]');
  if (!root) return;
  const list = root.querySelector('[data-pn-reader-items]');
  const status = root.querySelector('[data-pn-reader-status]');
  const key = 'pn-wishlist-preview-v1';
  const safeUrl = value => {
    try { const url = new URL(value); return ['https:', 'http:'].includes(url.protocol) ? url.href : ''; } catch { return ''; }
  };
  const read = () => {
    try { const value = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(value) ? value.filter(item => item && typeof item.title === 'string' && safeUrl(item.url)) : []; }
    catch { status.textContent = root.dataset.error; return []; }
  };
  const render = () => {
    const items = read();
    list.replaceChildren();
    if (!items.length) { const empty = document.createElement('p'); empty.textContent = root.dataset.empty; list.append(empty); }
    items.forEach(item => {
      const card = document.createElement('article');
      card.className = 'pn-reader__item';
      const image = document.createElement('img');
      const imageUrl = safeUrl(item.image);
      if (imageUrl) { image.src = imageUrl; image.alt = ''; image.loading = 'lazy'; card.append(image); }
      const body = document.createElement('div');
      const brand = document.createElement('p'); brand.textContent = item.brand || '';
      const heading = document.createElement('h3');
      const link = document.createElement('a'); link.href = safeUrl(item.url); link.rel = 'sponsored nofollow noopener'; link.textContent = item.title; heading.append(link);
      const price = document.createElement('p'); price.textContent = item.price || '';
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = root.dataset.remove; remove.setAttribute('aria-label', root.dataset.remove + ' ' + item.title);
      remove.addEventListener('click', () => {
        try { localStorage.setItem(key, JSON.stringify(read().filter(saved => saved.url !== item.url))); status.textContent = ''; render(); } catch { status.textContent = root.dataset.error; }
      });
      body.append(brand, heading, price, remove); card.append(body); list.append(card);
    });
  };
  window.addEventListener('storage', event => { if (event.key === key) render(); });
  window.addEventListener('pageshow', render);
  render();
})();
